import { render, staticRenderFns } from "./Urgency.vue?vue&type=template&id=bbf9a1b6&scoped=true"
import script from "./Urgency.vue?vue&type=script&lang=js"
export * from "./Urgency.vue?vue&type=script&lang=js"
import style0 from "./Urgency.vue?vue&type=style&index=0&id=bbf9a1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf9a1b6",
  null
  
)

export default component.exports